import { verifyMfa } from "api/services/user-service";
import useApiCall from "hooks/useApiCall";
import { useHandleLoginSuccess } from "hooks/useHandleLoginSuccess";
import { useCallback } from "react";
import { ITokenResponse } from "api/models/response/ITokenResponse";
import { IVerifyMfaRequest } from "api/models/request/IVerifyMfaRequest";

export const useVerifyMfa = () => {
    const { callAPI, loading } = useApiCall(verifyMfa, 'verifyMfa.success', 'verifyMfa.error');
    const { handleLoginSuccess } = useHandleLoginSuccess();

    const verifyMfaAndHandleLogin = useCallback(
        async (request: IVerifyMfaRequest) => {
            const response = await callAPI(request);
            if (response?.status === 200 && response.data && 'token' in response.data) {
                await handleLoginSuccess(response.data as ITokenResponse);
            }
            return response;
        },
        [callAPI, handleLoginSuccess]
    );

    return { verifyMfa: verifyMfaAndHandleLogin, verifyingMfa: loading };
};